import { Injectable } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class GlobalRecordService {
	recordSelectEvent: EventEmitter<{ eventType: string, recordId: number, recordValue: boolean, timestamp: Date }> = new EventEmitter();

	globalRecordIdsHash: { [key: number]: boolean } = {};

	setRecord(id: number, value: boolean, notify: boolean = false): void {
		this.globalRecordIdsHash[id] = value;

		if (notify) {
			this.recordSelectEvent.emit({
				eventType: 'recordSelection',
				recordId: id,
				recordValue: value,
				timestamp: new Date(),
			});
		}
	}

	getRecord(id: number): boolean {
		return this.globalRecordIdsHash[id] || false;
	}

	clear(): void {
		this.globalRecordIdsHash = {};
	}
}
